const binding = { modules: {}, dataActions: {} };

    (binding.modules['dobbies-default-metatags'] = {
        c: () => require('partner/modules/dobbies-default-metatags/dobbies-default-metatags.tsx'),
        $type: 'htmlHeadTagsModule',
        da: [],
        
        iNM: false,
        ns: '__local__',
        n: 'dobbies-default-metatags',
        p: '__local__',
        
        pdp: '',
        
        
        md: 'src/modules/dobbies-default-metatags'
    });
        

        
    window.__bindings__ = window.__bindings__ || {};
    window.__bindings__.modules = {
        ...window.__bindings__.modules || {},
        ...binding.modules
    };
    
        window.__bindings__.dataActions = {
        ...window.__bindings__.dataActions || {},
        ...binding.dataActions
    };